// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.cell-center {
  text-align: center;
}

.cell-center > * {
  margin: 0 auto;
}

.cell-right {
  text-align: right;
}

.cell-right > * {
  margin: 0 0 0 auto;
}

.d-flex {
  display: flex;
}

.number-cell {
  display: flex;
  align-items: center;
  justify-content: center;
}

.truncate-cell {
  min-width: 100px;
  /* Adjust the max width as needed */
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.p-0 {
  padding: 0;
}

.align-self-center {
  align-self: center;
}

.align-items-center {
  align-items: center;
}

.collapse-string {
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  width: 260px;
  /* display: block; */
  margin: auto;
}

.overflow-ellipse {
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  display: block;
  margin: auto;
}

.userpage-overflow {
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  display: block;
}

.d-block {
  display: block;
}

.m-auto {
  margin: auto;
}

.collapse-string::-webkit-line-clamp {
  display: block;
  margin: auto;
  white-space: nowrap;
  -webkit-line-clamp: 1;
  /* Number of lines to show */
  -webkit-box-orient: vertical;
  overflow: hidden;
  text-overflow: ellipsis;
  width: 260px;
  /* Set a width for the container */
}

.draggable-btn {
  top: 50%;
  /* left: 50%; */
  transform: translate(0%, -50%);
}

.cell-row {
  padding-top: 3px;
  padding-bottom: 3px;
  min-height: 44px;
}

.cell-header {
  padding-top: 4px;
  padding-bottom: 4px;
  height: 44px;
}

.justify-content-center {
  justify-content: center;
}

.MuiTableCell-root:not(:last-of-type):after {
  position: absolute;
  content: '';
  background-color: #334155;
  width: 1px;
  height: calc(100% - 30px);
  right: 0;
  top: 16px;
}
`, "",{"version":3,"sources":["webpack://./src/assets/third-party/react-table.css"],"names":[],"mappings":"AAAA;EACE,kBAAkB;AACpB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,iBAAiB;AACnB;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,uBAAuB;AACzB;;AAEA;EACE,gBAAgB;EAChB,mCAAmC;EACnC,gBAAgB;EAChB,uBAAuB;EACvB,mBAAmB;AACrB;;AAEA;EACE,UAAU;AACZ;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,mBAAmB;EACnB,gBAAgB;EAChB,uBAAuB;EACvB,YAAY;EACZ,oBAAoB;EACpB,YAAY;AACd;;AAEA;EACE,mBAAmB;EACnB,gBAAgB;EAChB,uBAAuB;EACvB,cAAc;EACd,YAAY;AACd;;AAEA;EACE,mBAAmB;EACnB,gBAAgB;EAChB,uBAAuB;EACvB,cAAc;AAChB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,YAAY;AACd;;AAEA;EACE,cAAc;EACd,YAAY;EACZ,mBAAmB;EACnB,qBAAqB;EACrB,4BAA4B;EAC5B,4BAA4B;EAC5B,gBAAgB;EAChB,uBAAuB;EACvB,YAAY;EACZ,kCAAkC;AACpC;;AAEA;EACE,QAAQ;EACR,eAAe;EACf,8BAA8B;AAChC;;AAEA;EACE,gBAAgB;EAChB,mBAAmB;EACnB,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;EAChB,mBAAmB;EACnB,YAAY;AACd;;AAEA;EACE,uBAAuB;AACzB;;AAEA;EACE,kBAAkB;EAClB,WAAW;EACX,yBAAyB;EACzB,UAAU;EACV,yBAAyB;EACzB,QAAQ;EACR,SAAS;AACX","sourcesContent":[".cell-center {\n  text-align: center;\n}\n\n.cell-center > * {\n  margin: 0 auto;\n}\n\n.cell-right {\n  text-align: right;\n}\n\n.cell-right > * {\n  margin: 0 0 0 auto;\n}\n\n.d-flex {\n  display: flex;\n}\n\n.number-cell {\n  display: flex;\n  align-items: center;\n  justify-content: center;\n}\n\n.truncate-cell {\n  min-width: 100px;\n  /* Adjust the max width as needed */\n  overflow: hidden;\n  text-overflow: ellipsis;\n  white-space: nowrap;\n}\n\n.p-0 {\n  padding: 0;\n}\n\n.align-self-center {\n  align-self: center;\n}\n\n.align-items-center {\n  align-items: center;\n}\n\n.collapse-string {\n  white-space: nowrap;\n  overflow: hidden;\n  text-overflow: ellipsis;\n  width: 260px;\n  /* display: block; */\n  margin: auto;\n}\n\n.overflow-ellipse {\n  white-space: nowrap;\n  overflow: hidden;\n  text-overflow: ellipsis;\n  display: block;\n  margin: auto;\n}\n\n.userpage-overflow {\n  white-space: nowrap;\n  overflow: hidden;\n  text-overflow: ellipsis;\n  display: block;\n}\n\n.d-block {\n  display: block;\n}\n\n.m-auto {\n  margin: auto;\n}\n\n.collapse-string::-webkit-line-clamp {\n  display: block;\n  margin: auto;\n  white-space: nowrap;\n  -webkit-line-clamp: 1;\n  /* Number of lines to show */\n  -webkit-box-orient: vertical;\n  overflow: hidden;\n  text-overflow: ellipsis;\n  width: 260px;\n  /* Set a width for the container */\n}\n\n.draggable-btn {\n  top: 50%;\n  /* left: 50%; */\n  transform: translate(0%, -50%);\n}\n\n.cell-row {\n  padding-top: 3px;\n  padding-bottom: 3px;\n  min-height: 44px;\n}\n\n.cell-header {\n  padding-top: 4px;\n  padding-bottom: 4px;\n  height: 44px;\n}\n\n.justify-content-center {\n  justify-content: center;\n}\n\n.MuiTableCell-root:not(:last-of-type):after {\n  position: absolute;\n  content: '';\n  background-color: #334155;\n  width: 1px;\n  height: calc(100% - 30px);\n  right: 0;\n  top: 16px;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
